import { equal, not, readOnly } from '@ember/object/computed';

import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  externalType: [
    validator('presence', true),
    validator('unique-in-relation', {
      relation: readOnly('model.product.externalValues'),
      messageKey: 'forms.external-value.messages.externalType.unique',
      dependentKeys: ['model.product.externalValues.@each.externalType'],
    }),
  ],
  externalId: [
    validator('presence', true),
    validator('format', {
      regex: /^-1|spotify:[a-z]+:[a-z,A-Z,0-9]+$/,
      messageKey: 'forms.external-value.messages.externalId.spotify',
      disabled: not('model.isSpotify'),
    }),
  ],
});

export default class ExternalValueModel extends Model.extend(Validations) {
  @attr('string') externalType;
  @attr('string') externalId;
  @attr preOrderDate;

  // CMS fields
  @attr('number') position;

  // Relations
  @belongsTo('product', { async: true, inverse: 'externalValues' }) product;

  // Getter, setter and computed properties
  @equal('externalType', 'spotify') isSpotify;

  get displayLabel() {
    return `${this.externalType} (${this.externalId})`;
  }
}
